import { CheckCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert, Col, Modal, Row, Typography } from "antd";
import React from "react";

interface UploadNotAlerts {
  open: boolean;
  onCancel: () => void;
  order_no: string[];
  diff_order_no: string[];
  platfrom: string;
  brand: string;
  platfrom_id: number;
  shop_id: string;
  preImage: string;
  timeUsed: number;
  uploadTime: string;
}

const { confirm } = Modal;
const UploadNotAlert: React.FC<UploadNotAlerts> = ({
  open,
  onCancel,
  order_no,
  diff_order_no,
  platfrom,
  brand,
  preImage,
  uploadTime,
}) => {
  const initialTime = diff_order_no.length * 4;
  const formatTime = (totalTimeInSeconds: number) => {
    const days = Math.floor(totalTimeInSeconds / (3600 * 24));
    const hours = Math.floor((totalTimeInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
    const seconds = totalTimeInSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const {
    days: usedDays,
    hours: usedHours,
    minutes: usedMinutes,
    seconds: usedSeconds,
  } = formatTime(initialTime);
  const displayTimeUsed = () => {
    const timeUnits = [
      usedDays > 0 ? `${usedDays} days` : "",
      usedHours > 0 ? `${usedHours} hours` : "",
      usedMinutes > 0 ? `${usedMinutes} minutes` : "",
      usedSeconds > 0 ? `${usedSeconds} seconds` : "",
    ];

    return timeUnits.filter((unit) => unit !== "").join(" ");
  };

  const handleCancel = () => {
    confirm({
      title: "ต้องการที่จะปืดใช่ไหม?",
      icon: <ExclamationCircleOutlined style={{ fontSize: "40px", color: "#faad14" }} />, // Increase icon size
      content: (
        <div style={{ paddingLeft: "18px" }}>ถ้าปิดระบบจะยังทำงานอยู่ตามเวลาที่ประมาณค่าไว้.</div>
      ),
      okText: "Yes",
      cancelText: "No",
      onOk() {
        onCancel();
      },
    });
  };

  return (
    <Modal open={open} onCancel={handleCancel} footer={null} width={700} centered>
      <div style={{ textAlign: "center", padding: "0px 20px 20px 20px" }}>
        <Row justify="center" align="middle" style={{ marginBottom: "20px" }}>
          <Col>
            <CheckCircleFilled
              style={{ fontSize: "30px", color: "#52c41a", marginRight: "8px", marginTop: "16px" }}
            />
          </Col>
          <Col>
            <Typography.Title level={2} type="success">
              Order ครบถ้วน
            </Typography.Title>
          </Col>
        </Row>
        <div style={{ transform: "scale(2.5)", display: "inline-block" }}>
          <img
            src={preImage}
            alt="Success"
            style={{ width: "150px", marginTop: "20px", marginBottom: "20px" }}
          />
        </div>
        <Row justify="center" align="middle" style={{ marginTop: "40px" }}>
          <Col span={12}>
            <Typography.Text strong style={{ fontSize: "22px", color: "#656565" }}>
              Platform: {platfrom}
            </Typography.Text>
          </Col>
          <Col span={12}>
            <Typography.Text strong style={{ fontSize: "22px", color: "#656565" }}>
              Brand: {brand}
            </Typography.Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]} justify="center" style={{ marginTop: "30px" }}>
          <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
            <div style={highlightBoxStyle("#ffa500")}>
              <Typography.Text strong style={highlightTextStyle}>
                จำนวนที่ขาด: {diff_order_no.length}
              </Typography.Text>
            </div>
          </Col>
          <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
            <div style={highlightBoxStyle("#007bff")}>
              <Typography.Text strong style={highlightTextStyle}>
                จำนวนทั้งหมด: {order_no.length}
              </Typography.Text>
            </div>
          </Col>
        </Row>
        <Alert
          message="ตรวจสอบครบถ้วน"
          description={
            <>
              <Col>
                <Typography.Text strong style={{ color: "green" }}>
                  เวลาที่ใช้โดยประมาณ : {displayTimeUsed()}{" "}
                </Typography.Text>{" "}
                ออร์เดอทั้งหมดได้รับการตรวจสอบแล้ว ไม่มีออร์เดอที่ต้องตรวจสอบใหม่.
              </Col>
              <Col style={{ marginTop: "10px" }}>
                <Typography.Text strong style={{ color: "black" }}>
                  * Uploaded at: {uploadTime}
                </Typography.Text>
              </Col>
            </>
          }
          type="success"
          showIcon
          style={{ textAlign: "left", marginTop: "20px" }}
        />
      </div>
    </Modal>
  );
};

const highlightBoxStyle = (backgroundColor: string): React.CSSProperties => ({
  backgroundColor,
  padding: "10px",
  borderRadius: "8px",
  textAlign: "center",
  width: "100%",
  maxWidth: "200px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
});

const highlightTextStyle: React.CSSProperties = {
  fontSize: "18px",
  color: "#fff",
};

export default UploadNotAlert;
